module.exports = __webpack_public_path__ + "static/media/app-mockup.3e10c3f9.png";